import { Button } from "@website/ui-old/button";
import { useMonthActions } from "@website/ui-old/datepicker/components/month-actions/month-actions.hook";
import styles from "@website/ui-old/datepicker/components/month-actions/month-actions.module.scss";
import { MonthActionsPropertiesType } from "@website/ui-old/datepicker/components/month-actions/month-actions.types";
import { numberConvert } from "@website/utils/number-convert";
import { FC, Fragment, memo } from "react";

const MONTH_NAMES: Record<string, Array<string>> = {
  persian: [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند"
  ],
  gregorian: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};

const MonthActions: FC<MonthActionsPropertiesType> = (properties) => {
  const { calendarLocale = "gregorian", showDates } = properties;

  const { showPreviousMonthButtonProperties, showNextMonthButtonProperties } =
    useMonthActions(properties);

  return (
    <div className={`${styles["container"]} ${styles["rtl" || "ltr"]}`}>
      <Button
        {...showPreviousMonthButtonProperties}
        className={styles["month-button"]}
      />
      {showDates
        ? showDates.map((item, index) => (
            <Fragment key={item.month}>
              {index > 0 ? (
                <div className={styles["month-name-divider"]} />
              ) : null}
              <div
                className={styles["month-name"]}
                key={`${item?.year}-${item.month}`}
              >
                {
                  (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
                    item.month - 1
                  ]
                }{" "}
                {numberConvert(item.year, {
                  numberOnly: true,
                  locale: "fa"
                })}
                {(calendarLocale === "persian" && String("fa") !== "fa") ||
                (calendarLocale === "gregorian" && String("fa") !== "en") ? (
                  <span className={styles["month-name-native"]}>
                    (
                    {
                      (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
                        item.month - 1
                      ]
                    }
                    )
                  </span>
                ) : null}
              </div>
            </Fragment>
          ))
        : null}
      <Button
        {...showNextMonthButtonProperties}
        className={styles["month-button"]}
      />
    </div>
  );
};

const MonthActionsMemoized = memo(MonthActions);
/**
 * @deprecated please use @website/ui instead
 */
export { MonthActionsMemoized /**
 * @deprecated please use @website/ui instead
 */ as MonthActions };
